import React, { useState } from 'react';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';

import {
  DISTRICT_INDEX,
  COUNTRY_NAME_INDEX,
  COUNTRY_CODE_INDEX,
  SUBSCRIPTION_NUMBERS_INDEX,
  USER_EMAIL_INDEX,
  activeMarketsArrayType,
  DataTableRowTypes
} from "./ActiveMarkersConst";

const columns: GridColDef[] = [
  {
    field: 'id',
    headerName: 'ID',
    width: 80,
  },
  {
    field: 'district',
    headerName: 'District Name',
    width: 200,
  },
  {
    field: 'countryName',
    headerName: 'Country Name',
    width: 200,
  },
  {
    field: 'countryCode',
    headerName: 'Country Code',
    width: 200,
  },
  {
    field: 'subscriptionNumber',
    headerName: 'Subscription Number',
    width: 150,
    type: 'number',
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 400,
  }
];

const DataTable = ({ markets }: { markets: activeMarketsArrayType[] }) => {
  const [noOfRows, setNoOfRows] = useState<number>(50);
  const rows: DataTableRowTypes[] = [];
  markets.forEach((market, i) => {
    rows.push({
      id: i + 1,
      district: market[DISTRICT_INDEX],
      countryName: market[COUNTRY_NAME_INDEX],
      countryCode: market[COUNTRY_CODE_INDEX],
      subscriptionNumber: market[SUBSCRIPTION_NUMBERS_INDEX],
      email: market[USER_EMAIL_INDEX]?.split(",").join("  |  ")
    });
  });

  return (
    <DataGrid rows={rows} columns={columns} pageSize={noOfRows}
      rowsPerPageOptions={[5, 10, 50, 100]}
      onPageSizeChange={(e) => {
        setNoOfRows(e);
      }}
    />    
  );
};

export default DataTable;
